/**
 * DeleteAllButton component for removing all flashcards.
 * Shows spinner during deletion operation.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Callback when button is clicked
 * @param {boolean} props.isDeleting - Whether deletion is in progress
 * @param {string} [props.label] - Accessible label for the button
 * @returns {React.ReactElement} Delete all button
 */
export default function DeleteAllButton({
  onClick,
  isDeleting,
  label = 'Usuń wszystkie fiszki',
}) {
  return (
    <button
      type="button"
      className="delete-all-button"
      onClick={onClick}
      disabled={isDeleting}
      aria-label={label}
      aria-busy={isDeleting}
    >
      {isDeleting ? (
        <>
          <span
            className="delete-all-button__spinner"
            aria-hidden="true"
          ></span>
          <span className="delete-all-button__text">Usuwanie...</span>
        </>
      ) : (
        <span className="delete-all-button__text">Usuń wszystkie</span>
      )}
    </button>
  )
}
